import { setMetaDescription } from 'utils';

const ProfileMetaHook = (Component) => (props) => {
  const setMeta = (barber) => {
    const name = barber.display_name || barber.name;
    const content = `Check out ${name} - explore services, pricing, reviews and previous work. ${barber.about}`;
    document.title = `${name} - Book online with Barbr`;
    setMetaDescription(content);
  };

  return <Component {...props} updateMeta={setMeta} />;
};

export default ProfileMetaHook;
